<template>
  <div class="follow-up-assistant">
    <div class="top">
      <div class="top-tabs">
        <div
          v-for="item in tabs"
          :key="item.value"
          class="top-tabs__item"
          :class="{ 'top-tabs__item--active': activeTab === item.value }"
          @click="activeTab = item.value"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="box">
      <TabStorage v-if="activeTab === 'storage'" />
      <TabAnalysis v-else-if="activeTab === 'analysis'" />
      <TabAdvice v-else-if="activeTab === 'advice'" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import TabStorage from './components/tab-storage.vue'
import TabAnalysis from './components/tab-analysis.vue'
import TabAdvice from './components/tab-advice.vue'

const activeTab = ref('storage')
const tabs = [
  { label: '跟进入库', value: 'storage' },
  { label: '跟进分析', value: 'analysis' },
  { label: '跟进建议', value: 'advice' }
]
</script>

<style lang="scss" scoped>
// 文字/Text-4 强调正文标题
$text-strong: #323233;
// 文字/Text-3 次强调正文标题
$text-secondary: #646566;
// 拓展色/紫罗兰/Violets-6
$violet-6: #7a52f4;

.follow-up-assistant {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .top {
    flex: 0 0 auto;
    height: 51px;
    padding: 12px 0;
    box-sizing: border-box;
  }

  .top-tabs {
    height: 27px;
    text-align: center;
    font-size: 0;

    &__item {
      position: relative;
      display: inline-block;
      min-width: 80px;
      height: 27px;
      padding: 0 12px;
      box-sizing: border-box;
      color: $text-secondary;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      vertical-align: top;
      cursor: pointer;

      & + & {
        margin-left: 0;
      }

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        width: 20px;
        height: 3px;
        border-radius: 4px;
        background: transparent;
        transform: translateX(-50%);
      }
    }

    &__item--active {
      color: $text-strong;
      font-weight: 600;

      &::after {
        background: $violet-6;
      }
    }
  }

  .box {
    flex: 1;
    overflow-y: auto;
    padding: 16px 0;
  }
}
</style>
